import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { PopupAction } from '../../../../../../common/popup/PopupAction'

export const ConfirmDeletePanel = ({ isShow, handleClose, handleSubmit }) => {
  return (
    <PopupAction
      title="common.CONFIRMATION"
      isShow={isShow}
      handleClose={handleClose}
      btnSubmit={{
        label: 'common.YES',
        event: handleSubmit,
        isI18n: true,
      }}
      btnCancel={{
        label: 'common.NO',
        event: handleClose,
        isI18n: true,
      }}
    >
      <Element>
        <Translate value="dynamicReport.NOTE_DELETE" />
      </Element>
    </PopupAction>
  )
}
